module.exports = __webpack_public_path__ + "img/icon_viptcx.284f8ffe.png";